import VehicleType from '@/enums/VehicleType';
import VehicleLevel from '@/enums/VehicleLevel';
import VehicleStatusType from '@/enums/VehicleStatusType';

export default class VehicleModuleOptions {
  public vehicleType: VehicleType;

  public vehicleLevel: VehicleLevel;

  public vehicleStatusType: VehicleStatusType;

  public moduleKey: string = '';

  public restrictVehicles: boolean;

  constructor(vehicleType: VehicleType, vehicleLevel: VehicleLevel, vehicleStatusType: VehicleStatusType, restrictVehicles: boolean = true) {
    this.vehicleType = vehicleType;
    this.vehicleLevel = vehicleLevel;
    this.vehicleStatusType = vehicleStatusType;
    this.restrictVehicles = restrictVehicles;
  }
}
